module.exports = __webpack_public_path__ + "img/t-shirt.dee294e4.jpg";